import "@fontsource/montserrat";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/700.css";
import { createTheme } from "@mui/material/styles";

const darkFluorTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#032B66",
    },
    secondary: {
      main: "rgba(24, 59, 255, 1)",
    },
    background: {
      default: "#FFFFFF",
      paper: "#fdfdfdff",
    },
    text: {
      primary: "#121212",
      secondary: "#251a1aff",
    },
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    h1: { fontFamily: "'Montserrat', sans-serif" },
    h2: { fontFamily: "'Montserrat', sans-serif" },
    h3: { fontFamily: "'Montserrat', sans-serif" },
    body1: { fontFamily: "'Montserrat', sans-serif" },
    button: { fontFamily: "'Montserrat', sans-serif" },
  },
});

export default darkFluorTheme;
